import { useEffect } from "react";
import { trackVisit } from "../lib/api";
import PageHero from "../components/site/PageHero";
import QuoteTable from "../components/site/QuoteTable";

export default function Quotazioni() {
  useEffect(() => { trackVisit("quotazioni"); }, []);

  return (
    <div data-testid="quotazioni-page">
      <PageHero
        eyebrow="Quotazione Live"
        title="Le nostre quotazioni"
        titleAccent="di oggi."
        subtitle="Prezzi di borsa aggiornati dal fixing internazionale di BullionVault. Per il reale valore del tuo oro o argento contattaci al 338 947 2101."
      />

      <section className="py-16">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
          <QuoteTable />

          <div className="mt-12 grid md:grid-cols-3 gap-5">
            {[
              ["Aggiornate Quotidianamente", "Monitoriamo il mercato BullionVault ogni giorno per offrirvi sempre il prezzo più equo."],
              ["Nessuno Spread Nascosto", "La quotazione esposta è la quotazione applicata. Punto."],
              ["Pagamento Immediato", "Al termine della valutazione, riceverete subito il pagamento."],
            ].map(([t, d], i) => (
              <div key={i} className="luxe-card p-7">
                <h4 className="font-serif text-xl text-white mb-2">{t}</h4>
                <p className="text-sm text-[var(--text-secondary)]">{d}</p>
              </div>
            ))}
          </div>

          <p className="text-xs text-white/30 mt-10 max-w-3xl">
            * Le quotazioni riportate sono <strong>prezzi di borsa</strong> del mercato internazionale dei metalli preziosi (fonte BullionVault) e hanno valore puramente indicativo. Il <strong>prezzo reale di acquisto</strong> del tuo oggetto viene determinato in negozio al termine della valutazione tecnica considerando peso, caratura effettiva, condizione e valore intrinseco. Contatta il 338 947 2101 per un preventivo personalizzato.
          </p>
        </div>
      </section>
    </div>
  );
}
